const displayError = (error, message) => {
  document.getElementById("snackbar2") &&
    (document.getElementById("snackbar2").open = true);
  document.getElementById("snackbar2") &&
    (document.getElementById("snackbar2").type = error);
  document.getElementById("snackbar2") &&
    (document.getElementById("snackbar2").message = message);
};

export default displayError;
